import { checkAppInstalledSyncWithTimeout } from '@/utils/appInstallCheck.js'
import { Dialog, Toast } from 'vant'
import slsLogger from '@/utils/slsLogger'

export default {
/**
* @description h5页面跳转对应手机应用商店的方法
* @param  navigator.userAgent 获取手机的系统信息
* @author bingding
* @time 20210326
*/
  RouterAppStoreqq () {
    const sUserAgent = navigator.userAgent.toLowerCase()
    const isIphone = sUserAgent.indexOf('iphone') === -1
    // const isHuawei = sUserAgent.indexOf('huawei') === -1
    // const isHonor = sUserAgent.indexOf('honor') === -1
    // const isOppo = sUserAgent.indexOf('oppo') === -1
    // const isOppoR15 = sUserAgent.indexOf('pacm00') === -1
    // const isVivo = sUserAgent.indexOf('vivo') === -1
    // const isXiaomi = sUserAgent.indexOf('mi') === -1
    // const isXiaomi2s = sUserAgent.indexOf('mix') === -1
    // const isRedmi = sUserAgent.indexOf('redmi') === -1
    // const isSamsung = sUserAgent.indexOf('sam') === -1
    if (!isIphone) {
    //   window.location.href = window.location.href = 'https://apps.apple.com/cn/app/%E5%B9%BC%E5%AD%A6%E4%B8%AD%E6%96%87/id1507879856'
      window.location.href = 'https://apps.apple.com/cn/app/%E5%B9%BC%E5%AD%A6%E4%B8%AD%E6%96%87/id1507879856'
    } else {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.iflytek.preeducation'
    }
    //  else if (!isHuawei || !isHonor) {
    //   window.location.href = 'appmarket://details?id=com.iflytek.preeducation'
    // } else if (!isOppo || !isOppoR15) {
    //   window.location.href = 'oppomarket://details?packagename=com.iflytek.preeducation'
    // } else if (!isVivo) {
    //   window.location.href = 'vivomarket://details?id=com.iflytek.preeducation'
    // } else if (!isXiaomi || !isRedmi || !isXiaomi2s) {
    //   window.location.href = 'mimarket://details?id=com.iflytek.preeducation'
    // } else if (!isSamsung) {
    //   window.location.href = 'samsungapps://ProductDetail/com.iflytek.preeducation'
    // } else {
    //   window.location.href = 'oppomarket://details?packagename=com.iflytek.preeducation'
    // }
  },
  // 识字app下载协议
  RouterAppStore () {
    const sUserAgent = navigator.userAgent.toLowerCase()
    const isIphone = sUserAgent.indexOf('iphone') !== -1
    const isIpad = sUserAgent.indexOf('ipad') !== -1
    const isXiaomi = sUserAgent.indexOf('mi') !== -1
    const isXiaomi2s = sUserAgent.indexOf('mix') !== -1
    const isRedmi = sUserAgent.indexOf('redmi') !== -1

    if (isIphone || isIpad) {
      console.log('isIphone || || isIpad:', 'true')
      window.location.href = 'https://apps.apple.com/cn/app/%E5%B9%BC%E5%AD%A6%E4%B8%AD%E6%96%87/id1507879856'
    } else if (isXiaomi || isXiaomi2s || isRedmi) {
      window.location.href = 'mimarket://details?id=com.iflytek.preeducation'
    } else {
      window.location.href = 'market://details?id=com.iflytek.preeducation'
    }
  },
  // 拼音app下载协议
  PyRouterAppStore () {
    const sUserAgent = navigator.userAgent.toLowerCase()
    const isIphone = sUserAgent.indexOf('iphone') === -1
    const isHuawei = sUserAgent.indexOf('huawei') === -1
    const isHonor = sUserAgent.indexOf('honor') === -1
    const isOppo = sUserAgent.indexOf('oppo') === -1
    const isOppoR15 = sUserAgent.indexOf('pacm00') === -1
    const isVivo = sUserAgent.indexOf('vivo') === -1
    const isXiaomi = sUserAgent.indexOf('mi') === -1
    const isXiaomi2s = sUserAgent.indexOf('mix') === -1
    const isRedmi = sUserAgent.indexOf('redmi') === -1
    const isSamsung = sUserAgent.indexOf('sam') === -1
    if (!isIphone) {
    //   window.location.href = window.location.href = 'https://apps.apple.com/cn/app/%E5%B9%BC%E5%AD%A6%E4%B8%AD%E6%96%87/id1507879856'
      window.location.href = 'https://apps.apple.com/cn/app/%E7%86%8A%E5%B0%8F%E7%90%83%E6%8B%BC%E9%9F%B3/id1592943356'
    } else if (!isHuawei || !isHonor) {
      window.location.href = 'appmarket://details?id=com.iflytek.preeducationpy'
    } else if (!isOppo || !isOppoR15) {
      window.location.href = 'oppomarket://details?packagename=com.iflytek.preeducationpy'
    } else if (!isVivo) {
      window.location.href = 'vivomarket://details?id=com.iflytek.preeducationpy'
    } else if (!isXiaomi || !isRedmi || !isXiaomi2s) {
      window.location.href = 'mimarket://details?id=com.iflytek.preeducationpy'
    } else if (!isSamsung) {
      window.location.href = 'samsungapps://ProductDetail/com.iflytek.preeducationpy'
    } else {
      // window.location.href = 'oppomarket://details?packagename=com.iflytek.preeducation'
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.iflytek.preeducationpy'
    }
  },
  // 熊小球识字app跳转（先唤起，未安装则弹窗引导下载）
  RouterXiongXiaoQiuApp (params = {}) {
    const { loginData = '', source = 'h5' } = params
    const self = this

    const sUserAgent = navigator.userAgent.toLowerCase()
    const isIphone = sUserAgent.indexOf('iphone') !== -1
    const isIpad = sUserAgent.indexOf('ipad') !== -1

    slsLogger.logFlowStep('RouterXiongXiaoQiuApp_start', 'info', {
      source,
      platform: isIphone || isIpad ? 'iOS' : 'Android',
      hasLoginData: !!loginData
    })

    if (isIphone || isIpad) {
      console.log('isIphone || isIpad:', 'true')
      slsLogger.logFlowStep('RouterXiongXiaoQiuApp_iOS_branch', 'info', {
        isIphone,
        isIpad,
        source,
        hasLoginData: !!loginData
      })
      // iOS/iPad 跳转逻辑 - 使用 iOS 提供的 openHtmlApp00 方法

      // 检查 iOS 原生方法是否存在
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openHtmlApp00) {
        slsLogger.logFlowStep('RouterXiongXiaoQiuApp_iOS_openHtmlApp00_available', 'info', {
          hasWebkitMessageHandlers: true
        })
        try {
          // 生成 scheme
          const scheme = `xxqsz://h5login/login?loginData=${encodeURIComponent(loginData)}&source=${encodeURIComponent(source)}`
          const downloadUrl = 'https://apps.apple.com/cn/app/%E5%B9%BC%E5%AD%A6%E4%B8%AD%E6%96%87/id1507879856'

          slsLogger.logFlowStep('RouterXiongXiaoQiuApp_iOS_scheme_built', 'info', {
            source,
            downloadUrl,
            hasLoginData: !!loginData
          })

          // 从 loginData 中提取 accessToken 作为 token 参数
          // loginData 是 JSON 字符串，包含 { accessToken, openId, clientId, sig, state }
          let accessToken = ''
          try {
            const loginDataObj = JSON.parse(loginData)
            accessToken = loginDataObj.accessToken || ''
          } catch (e) {
            console.warn('解析 loginData 失败:', e)
            slsLogger.logError('RouterXiongXiaoQiuApp_parseLoginData', e, {
              loginDataLength: typeof loginData === 'string' ? loginData.length : 0
            })
          }

          // 调用 iOS 原生方法
          window.webkit.messageHandlers.openHtmlApp00.postMessage({
            param1: 2,
            param2: scheme,
            param3: '',
            param4: downloadUrl,
            param5: accessToken
          })

          slsLogger.logFlowStep('RouterXiongXiaoQiuApp_iOS_openHtmlApp00', 'success', {
            downloadUrl,
            hasAccessToken: !!accessToken,
            hasLoginPayload: !!loginData
          })
        } catch (error) {
          console.error('调用 iOS openHtmlApp00 失败:', error)
          slsLogger.logError('RouterXiongXiaoQiuApp_iOS_openHtmlApp00', error, { source })
          // 降级方案：直接跳转应用商店
          self.RouterAppStore()
        }
      } else {
        // 如果不在 iOS WebView 环境中，降级到应用商店
        console.log('非 iOS WebView 环境，跳转应用商店')
        slsLogger.logFlowStep('RouterXiongXiaoQiuApp_iOS_fallbackToStore', 'warning', {
          reason: '非 iOS WebView 环境'
        })
        self.RouterAppStore()
      }
    } else {
      Toast.loading({ message: '正在跳转...', forbidClick: true, duration: 0 })

      // Android 跳转逻辑
      const scheme = `xxqsz://h5login/login?loginData=${encodeURIComponent(loginData)}&source=${encodeURIComponent(source)}`
      slsLogger.logFlowStep('RouterXiongXiaoQiuApp_Android_schemeCall', 'info', {
        source,
        hasLoginPayload: !!loginData
      })

      checkAppInstalledSyncWithTimeout(scheme, (_, isInstalled) => {
        Toast.clear()
        slsLogger.logFlowStep('RouterXiongXiaoQiuApp_Android_checkResult', 'info', { isInstalled })
        if (!isInstalled) {
          Dialog.confirm({
            title: '提示',
            message: '检测到您未安装熊小球识字App，是否前往下载？',
            confirmButtonText: '去下载',
            cancelButtonText: '取消'
          }).then(() => {
            slsLogger.logFlowStep('RouterXiongXiaoQiuApp_Android_confirmDownload', 'success', {})
            self.RouterAppStore()
          }).catch(() => {
            slsLogger.logError('RouterXiongXiaoQiuApp_Android_cancelDownload', { message: '用户取消前往下载' }, {
              source,
              hasLoginPayload: !!loginData
            })
          })
        }
      }, 4000)
    }
  },
  // 家庭端app下载地址
  HomeRouterAppStore () {
    const sUserAgent = navigator.userAgent.toLowerCase()
    const isAndroid = sUserAgent.indexOf('iphone') === -1
    if (!isAndroid) { // iphone
      window.location.href = 'https://apps.apple.com/app/id1634603578'
    } else {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.iflytek.preeducation'
    }
  }
}
